export const AI_CHAT_LAUNCHER_LABEL = 'Open Flatshow.AI';
export const AI_CHAT_OVERLAY_Z_INDEX = 200002;
export const AI_CHAT_TOOLTIP_Z_INDEX = AI_CHAT_OVERLAY_Z_INDEX + 1;
